import { createFileRoute, Outlet } from "@tanstack/react-router";

import Sidebar from "@/components/molecules/Sidebar";

export const Route = createFileRoute("/_authenticated/_sidebarLayout")({
  component: () => (
    <div className={"fixed inset-0 flex overflow-hidden bg-white"}>
      <Sidebar />
      <main className="min-w-0 flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  ),
});
